import { generateApiPath } from "@routes/generatePath";

const pathBase = `/medical-service-provider/reports/appointments/`;

export const medicalServiceProvider = {
  get: () => generateApiPath(pathBase),
};
